"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemas = void 0;
const header_1 = require("./header");
const post_mobile_event_request_1 = require("./mobile/post-mobile-event-request");
const post_mobile_events_request_1 = require("./mobile/post-mobile-events-request");
const post_error_response_1 = require("./post-error-response");
const post_response_1 = require("./post-response");
const post_flow_event_request_1 = require("./web/post-flow-event-request");
const post_flow_events_request_1 = require("./web/post-flow-events-request");
const web_post_event_request_1 = require("./web/web-post-event-request");
const web_post_events_request_1 = require("./web/web-post-events-request");
__exportStar(require("./pubsub"), exports);
exports.schemas = {
    api: {
        headers: header_1.CoreHeader,
        response: post_response_1.postResponse,
        errorResponse: post_error_response_1.postErrorResponse,
        web: {
            postTrackEvent: web_post_event_request_1.webPostEventRequest,
            postTrackEvents: web_post_events_request_1.webPostEventsRequest,
            postTrackFlowEvent: post_flow_event_request_1.postFlowEventRequest,
            postTrackFlowEvents: post_flow_events_request_1.postFlowEventsRequest,
        },
        mobile: {
            postTrackEvent: post_mobile_event_request_1.postMobileEventRequest,
            postTrackEvents: post_mobile_events_request_1.postMobileEventsRequest,
        },
    },
};
//# sourceMappingURL=index.js.map